// src/contentDefault.js
const contentDefault = {
  general: {
    siteName: "Komponistinnen Musikfestival",
    heroTitle: "3. Edition des Komponist*Innen Musikfestivals",
    heroSubtitle: "23. - 25. November 2024",
  },

  carousel: {
    slides: [
      {
        imageUrl: "/img/slider/slide2.jpg",
        heading1: "3. Edition des Komponist*Innen Musikfestivals",
        heading2: "23. - 25. November 2024",
        ctaText: "Ticket reservieren",
        ctaHref: "#Ticketreservierung",
        animation1: "fadeInDown",
        animation2: "fadeInDown",
        ctaAnimation: "fadeInLeft",
      },
      {
        imageUrl: "/img/slider/slide1.JPG",
        heading1: "Internationale Künstler*innen",
        heading2: "",
        ctaText: "Mehr erfahren",
        ctaHref: "#Künstler*Innen",
        animation1: "bounceIn",
        animation2: "",
        ctaAnimation: "fadeInUp",
      },
      {
        imageUrl: "/img/slider/slide3.JPG",
        heading1: "Reservieren sie jetzt ihr ticket!",
        heading2: "",
        ctaText: "Ticket reservieren",
        ctaHref: "#Ticketreservierung",
        animation1: "fadeInUp",
        animation2: "",
        ctaAnimation: "fadeInUp",
      },
    ],
  },

  about: {
    sectionId: "ÜberDasFestival",
    title: "Über das Festival",
    imageUrl: "/img/about/about.jpg",
    greetingTitle: "Grußwort",
    paragraphs: [
      "Als Gründerin und künstlerische Leiterin des Komponistinnen Musikfestivals in Frankfurt am Main heiße ich Sie herzlich auf unserer Website willkommen. Das KomponistInnen Musikfestival wurde im Jahr 2022 ins Leben gerufen und hat sich seitdem zu einem jährlichen Höhepunkt musikalischer Exzellenz entwickelt. Es ist weit mehr als nur eine musikalische Veranstaltung; es repräsentiert ein kulturelles Erbe, das wir in unserer Stadt Frankfurt mit Stolz bewahren und teilen. Wir sind fest davon überzeugt, dass unser Festival nicht nur die künstlerische Vielfalt in Frankfurt auf neue Weise bereichert, sondern auch einen positiven Einfluss auf die gesamte Musikszene der Stadt ausübt. Wir laden Sie herzlich dazu ein, Teil dieser musikalischen Reise zu werden und gemeinsam mit uns außergewöhnliche Talente und die Vielfalt der Komponistinnenmusik zu feiern. Werfen Sie einen Blick auf unser Programm und sichern Sie sich Ihre Tickets für dieses unvergessliche Erlebnis.",
      "Herzlichst",
      "Diana Sahakyan, Konzert Pianistin",
    ],
  },

  countdown: {
    title: "DAS FESTIVAL BEGINNT IN",
    // ISO date that your countdown script can use
    targetISO: "2024-11-23T20:00:00+01:00",
  },

  counters: {
    location: {
      venue: "Orangerie im Günthersburgpark",
      city: "Frankfurt am Main",
      icon: "lni-map",
    },
    dates: {
      range: "23. - 25. November, 2024",
      days: [
        { label: "Samstag", start: "20 Uhr", doors: "19:30 Uhr" },
        { label: "Sonntag", start: "18:30 Uhr", doors: "18:00 Uhr" },
        { label: "Montag", start: "20 Uhr", doors: "19:30 Uhr" },
      ],
      icon: "lni-timer",
    },
    seats: {
      label: "100 Verfügbare plätze",
      sub: "Reservieren sie ihr ticket unten!",
      icon: "lni-users",
    },
    extras: {
      label: "Getränke & snacks",
      sub: "Verpassen sie es nicht",
      icon: "lni-heart",
    },
  },

  schedule: {
    sectionId: "Konzerte",
    title: "KONZERTE",
    days: [
      {
        id: "monday",
        tabLabel: "Samstag",
        dateLabel: "23 November",
        time: { start: "20 Uhr", doors: "19:30 Uhr" },
        title: "Eröffnungskonzert - Frankreich und die Romantik",
        items: [
          "Cécile Chaminade – Ausgewählte Lieder im Fokus",
          "Mel Bonis - Klavierquartett B Dur op. 69",
          "Nadia Boulanger – 3 piéces pour violoncello et piano",
          "César Franck – Sonate für Klavier und Violine A - Dur",
        ],
      },
      {
        id: "tuesday",
        tabLabel: "Sonntag",
        dateLabel: "24 November",
        time: { start: "18:30 Uhr", doors: "18:00 Uhr" },
        title: "Deutschlands größte Meister und Meisterinnen",
        items: [
          "Fanny Hensel – „Das Jahr“ Klavier Solo",
          "Ludwig van Beethoven – Klaviertrio op.11 „Gassenhauer – Trio“",
          "Dana Barak (*1987) - Trio Ha Reut  für Klarinette, Violoncello und Klavier",
          "Fanny Hensel – Klaviertrio op.11 d - moll",
        ],
      },
      {
        id: "wednesday",
        tabLabel: "Montag",
        dateLabel: "25 November",
        time: { start: "20 Uhr", doors: "19:30 Uhr" },
        title: "Zwischen Tradition und Moderne: Brahms und Gubaidulina",
        items: [
          "Sofia Gubaidulina – Klavierquintett",
          "Johannes Brahms – Klavierquintett f – Moll, op. 34",
        ],
      },
    ],
  },

  artists: {
    sectionId: "Künstler*Innen",
    title: "Musiker*innen",
    entries: [
      {
        name: "Diana Sahakyan",
        role: "Klavier",
        imageUrl: "/img/team/team-01.JPG",
        website: "https://www.dianasahakyan.de/",
        bioParagraphs: [
          "Die in Armenien geborene Pianistin Diana Sahakyan ...",
          "Die Bühne wurde zu ihrem Zuhause, ...",
          "Ihre künstlerische Entdeckerfreude ...",
        ],
      },
      // ... (include all 13 the same way from your modalContent)
    ],
  },

  gallery: {
    sectionId: "Galerie",
    title: "Festival-Galerie",
    images: [
      "/img/gallery/img-1.JPG",
      "/img/gallery/img-2.JPG",
      "/img/gallery/img-3.JPG",
      "/img/gallery/img-4.JPG",
      "/img/gallery/img-5.JPG",
      "/img/gallery/img-6.JPG",
    ],
  },

  tickets: {
    sectionId: "Tickets",
    title: "Tickets",
    ctaAnchor: "#Ticketreservierung",
    tiers: [
      { title: "Ticket Normalpreis", price: "€20", icon: "lni-ticket" },
      { title: "Ticket Ermäßigt", price: "€15", icon: "lni-ticket" },
      { title: "Kombiticket", price: "€50", icon: "lni-ticket" },
    ],
  },

  reservations: {
    sectionId: "Ticketreservierung",
    title: "Ticketreservierung",
  },

  contact: {
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2557.668828225911!2d8.704975396511683!3d50.12991871213213!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bd0fc43eaab613%3A0x21839f3d431ee7db!2sOrangerie!5e0!3m2!1sen!2sde!4v1692725495647!5m2!1sen!2sde",
  },
};

export default contentDefault;
